import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React from 'react';
import classNames from 'classnames';
import { Messages } from 'primereact/messages';

export const ForgotPasswordPage = () => {

    const [username, setUsername] = React.useState('');
    const [submitted, setSubmitted]  = React.useState(false);
    const [isLoading, setIsLoading]  = React.useState(false);
    
    const toast = React.useRef();
    const message = React.useRef();

    const showSuccess = (msg) => {
        message.current.show({ severity: 'success', content: msg, life: 90000 });
    };

    const showFailed = (message) => {
        toast.current.show({ severity: 'error', summary: 'Gagal', detail: message, life: 3000 });
    };

    const showError = (msg) => {
        toast.current.show({ severity: 'error', summary: 'Kesalahan', detail: msg, life: 3000 });
    };

    async function clickSubmit(event) {
        event.preventDefault();
        setSubmitted(true);

        if(!username) {         
            showError('username tidak boleh kosong!');               
        } else {
            const requestPayload = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*' 
                },
                body: JSON.stringify({
                    username: username
                })
            }
            setIsLoading(true);
            const response = await fetch('https://springboot-widy-app.widyan123.site/widy-app/forgot-password', requestPayload);
            const res = await response.json();
            if(response.status >= 200 && response.status <= 299) {                
                showSuccess(res.message);
            } else if(response.status >= 400 && response.status <= 499) {
                showFailed(res.message);
            } else {
                showError(res.message);
            }
            setIsLoading(false);
        }
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">                    
                <Toast ref={toast} />
                    <h5>Forgot Password</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
                <div className='card p-fluid'>
                    <Messages ref={message} />
                    <form onSubmit={clickSubmit}>
                        <div className="field">
                            <label htmlFor="username">Username</label>
                            <InputText id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} className={classNames({ 'p-invalid': submitted && !username })} />
                            {submitted && !username && <small className="p-error">Enter your username</small>}
                        </div>
                        <Button label="Submit" className="p-button-success mr-2" loading={isLoading} />
                    </form>
                </div>  
            </div>
        </div>
    );
}
